import React, { useRef, useEffect, useState, useContext, useCallback} from 'react';

import { useHistory } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import {FilterContext} from '../contexts/FilterContext';
import { PermissaoLoader } from './PermissaoLoader';

import {AuthContext} from '../contexts/AuthContext';
import { BrCalendar } from './BrCalendar';
import { permissions_check } from '../utils/rotas_permissao';

export const TabelaLoja = () => {
    const toast = useRef(null);
    const [lojistas, setLojistas] = useState([]);
    const [loja, setLoja] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const [dt, setDt] = useState(null);
    const history = useHistory();
    const { user, permissoes } = useContext(AuthContext);
    const [sortable, setSortable] = useState('ASC');
    const [sortableCampo, setSortableCampo] = useState('id');
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedLojistas, setSelectedLojistas] = useState(null);
    const filterLojista = renderFilterLojistas();
    const { filter, setFilter } = useContext(FilterContext);
    const [selectedDataEmissao, setSelectedDataEmissao] = useState(null);
    const [showActionsColumn, setShowActionsColumn] = useState(true);

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Loja</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                <PermissaoLoader rota="loja" acao="criar" onClick={() => history.push('/lojacreate')}  />
                </div>
                <div className="p-m-2">
                    <Button
                        label="Limpar Filtros"
                        className="p-mb-2 p-button-primary"
                        iconPos="left"
                        type="button"
                        onClick={() => handleLimparClick()}
                    />
                </div>
            </div>
        </div>

    );

    const handleLimparClick = () => {
        setFilter({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
                'id': { value: null, matchMode: 'equals' },
                'lojistaId': { value: null, matchMode: 'equals' },
                'dataEmissao': { value: '', matchMode: 'equals' },
            },

        });
        setSelectedLojistas(null);
        setSelectedDataEmissao(null);
    }

    const getLoja = useCallback(async (event) => {
        setIsLoading(true)
        setLoja([])

        // console.log(event)

        if(event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;

                setFirst(startIndex);
                // setLoja(dataSource.slice(startIndex, endIndex));
            }, 250);
        }

        try {

            // console.log(lazyParams.filters);
            if(filter.filters === undefined)
            {

                if(event === undefined) {
                    const response = await api.get(`loja?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(loja => {
                        setLoja(lojas => [...lojas, loja])
                    })
                } else {
                    const response = await api.get(`loja?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(loja => {
                        setLoja(lojas => [...lojas, loja])
                    })

                }

                const respElements = await api.get(`loja?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            }
            else
            {
                const pesquisa = {
                    "id": filter.filters['id'] !== undefined ? filter.filters['id'].value : null,
                    "lojistaId": filter.filters['lojistaId'] !== undefined ? filter.filters['lojistaId'].value : null,
                    "dataEmissao": filter.filters['dataEmissao'] !== undefined ? filter.filters['dataEmissao'].value : '',
                }
                // console.log(pesquisa)
                if (event === undefined) {
                    const respElements = await api.post(`loja/searchLoja/${sortable}/${sortableCampo}?`, pesquisa);
                    respElements.data.content.forEach(loja => {
                        setLoja(lojas => [...lojas, loja])
                    })
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`loja/searchLoja/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(loja => {
                        setLoja(lojas => [...lojas, loja])
                    })
                    setTotalRecords(respElements.data.totalElements);
                }
            }


        }
        catch (error) {

            if(filter !== undefined){
                if(event === undefined) {
                    const response = await api.get(`loja?sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(loja => {
                        setLoja(lojas => [...lojas, loja])
                    })
                } else {
                    const response = await api.get(`loja?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(loja => {
                        setLoja(lojas => [...lojas, loja])
                    })

                }

                const respElements = await api.get(`loja?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter loja', detail: error.toString() });
            }

        }

        setIsLoading(false)
    }, [filter,sortable,sortableCampo])

    useEffect(() => {
        const fetchLoja = async () => {
            try {
                await getLoja();

            }
            catch (error){
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        }
        fetchLoja();

    }, [getLoja])

    function renderFilterLojistas() {
        return (
            <Dropdown
                value={selectedLojistas}
                options={lojistas}
                optionValue='id'
                optionLabel='nome'
                onChange={(e) => onLojistasSearchChange(e)}
                placeholder="Selecione um lojista"
                emptyMessage="Nenhum lojista encontrado"
                emptyFilterMessage={"Nenhum lojista encontrado"}
                className="p-column-filter"
                showClear={true} />
        );
    }

    const onLojistasSearchChange = (event) => {
            if (event.value !== null) {
                dt.filter(event.value, 'lojistaId', 'equals');
                setSelectedLojistas(event.value);
            }
            else
                dt.filter(null, 'lojistaId', 'equals');
        }

        const actionBodyTemplate = (rowData) => {
            const hasEditPermission = permissions_check("loja", "editar", permissoes);
            const hasDeletePermission = permissions_check("loja", "deletar", permissoes);

            if (!hasEditPermission && !hasDeletePermission) {
                setShowActionsColumn(false);
                return null; // No actions to show
            }

            return (
                <div className="actions">
                        <PermissaoLoader rota="loja" acao="editar" onClick={() => handleEditClick(rowData)} />
                        <PermissaoLoader rota="loja" acao="deletar" loading={isDeleting} onClick={() => handleDeleteClick(rowData)} />
                </div>
            );
        };

    const codBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    }

    const lojistaBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Lojista</span>
                    <span className="table-data">{rowData.lojista.nome}</span>
                </p>
            </React.Fragment>
        );
    }

    const dataEmissaoBodyTemplate = (rowData) => {
        return(
            <React.Fragment>
                <p style={{textalign: 'left'}}>
                    <span className="p-column-title">Data Emissão</span>
                    <span className="table-data">{new Date(rowData.dataEmissao).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</span>
                </p>
            </React.Fragment>
        );
    }

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if(sortable === 'ASC'){
            setSortable('DESC')
        } else if (sortable === 'DESC') {
            setSortable('ASC')
        }
    }

    const onFilter = (event) => {
        event['first'] = 0;
        // setLazyParams(event);
        setFilter(event);
    }

    const handleEditClick = (data) => {

        history.push(`/loja/edit/${data.id}`);
    }

    const handleDeleteClick = (data) => {

        data['userEmail'] = user.email

        confirmDialog({
            message: `Você tem certeza que quer remover essa loja?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {
                    await api.delete(`loja/${data.id}`);
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Loja removida com sucesso` });
                    getLoja()
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a loja', detail: error.response.data });
                }

                setIsDeleting(false);
            },
            reject: () => { return }
        });
    }

    const getLojistas = useCallback(async () => {
        try {
            const response = await api.get(`pessoa/lojistas`);
            setLojistas(response.data)
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter lojistas', detail: error.toString() });
        }
    }, []);

    useEffect(() => {

        async function loja() {
            await getLojistas();
        };
        loja();
    }, [getLojistas])

    const onDataEmissaoSearchChange = (event) => {
        if (event.value !== null) {
            let data = new Date(event.value).toISOString();
            dt.filter(data, 'dataEmissao', 'equals');
            setSelectedDataEmissao(event.value);
        }
        else
            dt.filter(null, 'dataEmissao', 'equals');
    }

    const onDataEmissaoInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'dataEmissao', 'equals');
            setSelectedDataEmissao(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataEmissao', 'equals');
    }

    return (
        <>
        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable
                        totalRecords={totalRecords}
                        lazy="true"
                        first={first}
                        onPage={getLoja}
                        ref={(element) => setDt(element)}
                        header={header}
                        value={loja}
                        filterDisplay="row"
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma loja encontrada"
                        loading={isLoading}
                        dataKey="id"
                        paginator
                        rows={20}
                        currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} lojas`}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                        // rowsPerPageOptions={[10, 20, 30]}
                        onSort={onSort}
                        onFilter={onFilter}
                        filters={filter.filters}
                    >

                        <Column
                            field="id"
                            header="Código"
                            sortable={sortable}
                            body={codBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterPlaceholder={filter.filters !== undefined && (filter.filters.id !== undefined && filter.filters.id.value != null) ? filter.filters.id.value : "Pesquisar pelo Código"}

                        />

                        <Column
                            field="lojistaId"
                            header="Nome do Lojista"
                            sortable={sortable}
                            body={lojistaBodyTemplate}
                            filter
                            filterMatchMode="contains"
                            filterElement={filterLojista}
                        />


                            <Column
                            field="dataEmissao"
                            header="Data Emissão"
                            sortable
                            body={dataEmissaoBodyTemplate}
                            filter
                            filterElement={
                                <BrCalendar
                                    key={selectedDataEmissao}
                                    id="dataEmissao"
                                    name="dataEmissao"
                                    value={selectedDataEmissao}
                                    onSelect={(e) => onDataEmissaoSearchChange(e)}
                                    onInput={(e) => onDataEmissaoInputChange(e)}
                                    yearRange={`2000:${new Date().getFullYear() + 2}`}
                                    placeholder="Selecione uma data"
                                    onClearButtonClick={() => handleLimparClick()}
                                    disabledDays="none"
                                />
                            }
                        />

                    {showActionsColumn && (
                        <Column header="Ações" body={actionBodyTemplate} />
                    )}
                    </DataTable>

                </div>
            </div>
        </div>

        </>
    );
}
